import { LoanCalculations, LoanOption } from '@oneethos/shared'
import { Section } from './section'

type LoanInformationProps = {
  isResidential: boolean
  isStorageOnly?: boolean
  loanOptions: LoanOption[]
}

export const LoanInformation = ({
  isResidential,
  isStorageOnly = false,
  loanOptions
}: LoanInformationProps) => {

  const terms = loanOptions.map(
    loanOption => LoanCalculations.calculateLoanTermInYears(loanOption.product.term))

  let text = ''
  if (terms.length === 1) {
    text = `${terms[0]}-year loan term.`
  } else if (terms.length > 1) {
    const last = terms.pop()
    text = `${terms.join(', ')}, or ${last}-year loan terms.`
  }

  const loanTermInfo = isStorageOnly ?
    <li>{text}</li>
    : <li>
      Customers can choose from {text} (if qualified).
    </li>


  return (
    <Section>
      <div className="section-title">
        <h2 className="margin-bottom-0">Loan Information</h2>
      </div>
      <ul className="list fw-semibold fs-5 text d-flex flex-column gap-2">
        <li>
          Customers can save up to between 15-30% on project cost
          as OneEthos does not charge dealer fees.
        </li>
        {isResidential ? <>
          <li>Customers' monthly payment will never increase.</li>
          {loanTermInfo}
          <li>
            Customers receive a discounted interest rate when enrolled
            in Auto Pay.
          </li>
          <li>
            Climate First Bank clean energy loans are not to be used alongside any other financing products,
            such as a lease or power purchase agreement (PPA). Using funds for any purpose other than the purchase
            and installation of clean energy improvements to be owned by the customer will cause the loan to
            default and trigger remedies, including but not limited to, acceleration of loan repayment.
          </li>
        </> : <>
          <li>
            Clients can keep any tax credit. They can choose to apply
            the credit to towards the loan, bringing the monthly payment down.
          </li>
          <li>{text}</li>
        </>}
      </ul>
    </Section>
  )
}

export default LoanInformation